import React from "react";
import "./SubRowErrorBoundary.scss";

interface State {
    hasError: boolean;
    error: Error | null;
}

class SubRowErrorBoundary extends React.Component<React.PropsWithChildren, State> {
    state: State = { hasError: false, error: null };

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error("[HistorySubRow] Render error:", error, info.componentStack);

        // Suppress CRA dev overlay for caught errors
        const handler = (event: ErrorEvent) => {
            if (event.error === error) {
                event.preventDefault();
            }
        };
        window.addEventListener("error", handler, { once: true });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="subrow-error">
                    <span className="subrow-error__message">This history format is outdated, please contact support</span>
                </div>
            );
        }

        return this.props.children;
    }
}

export default SubRowErrorBoundary;
